import * as React from "react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Safety check to ensure React context is available
  if (typeof React === 'undefined' || !React.useContext) {
    return null;
  }
  
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast rounded-md shadow-lg border border-border backdrop-blur-sm",
          description: "text-xs opacity-90",
          success: "bg-green-600 text-white",
          error: "bg-red-600 text-white",
          warning: "bg-amber-500 text-black",
          info: "bg-indigo-600 text-white",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
